import { logo } from '../assets/images';
import styles from './AuthLayout.module.css';

export default function AuthLayout({ title, subtitle, children }) {
  return (
    <div className={styles.page}>
      <div className={styles.illustration} />
      <div className={styles.formArea}>
        <div className={styles.form}>
          <div className={styles.header}>
            <img src={logo} alt="InHence" className={styles.logo} />
            <h1 className={styles.heading}>{title}</h1>
          </div>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
          {children}
        </div>
      </div>
    </div>
  );
}

export { styles as authStyles };
